import * as React from "react";
import type { SVGProps } from "react";
const SvgEmpathy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M3.045 26.812a10.409 10.409 0 0 1 7.349-3.043c3.42 0 6.36 2.158 8.212 4.676 1.852-2.518 4.791-4.676 8.212-4.676 2.76 0 5.402 1.097 7.35 3.044a10.41 10.41 0 0 1 3.043 7.35c0 6.475-4.675 12.577-9.127 16.951a63.267 63.267 0 0 1-8.799 7.165l-.154.101-.04.026-.012.008-.003.002-.466-.727.465.728a.863.863 0 0 1-.465.135h-.009a.863.863 0 0 1-.464-.135l.464-.728c-.464.728-.464.727-.465.727l-.004-.002-.01-.008-.042-.026a39.047 39.047 0 0 1-.73-.49 63.286 63.286 0 0 1-8.223-6.776C4.675 46.739 0 40.638 0 34.162c0-2.76 1.097-5.402 3.044-7.35h.001Zm15.56 29.845a57.008 57.008 0 0 1-2.257-1.618 61.541 61.541 0 0 1-6.01-5.156c-4.418-4.34-8.612-10.002-8.612-15.72a8.668 8.668 0 0 1 8.668-8.668c3.082 0 5.897 2.282 7.468 4.952a.863.863 0 0 0 1.488 0c1.57-2.67 4.386-4.952 7.468-4.952a8.667 8.667 0 0 1 8.667 8.667c0 5.719-4.193 11.38-8.61 15.72a61.553 61.553 0 0 1-8.27 6.775Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M18.61 49.426s8.872-5.665 8.872-11.766a4.764 4.764 0 0 0-4.766-4.765c-1.751 0-3.28 1.28-4.106 2.689-.826-1.409-2.355-2.69-4.106-2.69A4.763 4.763 0 0 0 9.74 37.66c0 6.097 8.871 11.766 8.871 11.766Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.524 33.68a5.627 5.627 0 0 1 3.98-1.648c1.68 0 3.118.934 4.106 2.078.987-1.144 2.425-2.078 4.106-2.078a5.627 5.627 0 0 1 5.628 5.628c0 3.43-2.459 6.59-4.694 8.787a32.06 32.06 0 0 1-4.545 3.686l-.021.014-.007.004-.002.002-.465-.727-.465.727-.003-.002-.006-.004-.022-.014a15.952 15.952 0 0 1-.375-.252 32.1 32.1 0 0 1-4.17-3.436c-2.235-2.196-4.694-5.358-4.694-8.785 0-1.491.592-2.923 1.649-3.98Zm8.086 15.746-.465.727a.864.864 0 0 0 .93 0l-.465-.727Zm0-1.041a30.306 30.306 0 0 0 3.83-3.17c2.201-2.161 4.178-4.883 4.178-7.555a3.901 3.901 0 0 0-3.902-3.902c-1.331 0-2.623 1.002-3.362 2.262a.863.863 0 0 1-1.488 0c-.74-1.26-2.03-2.262-3.362-2.262a3.901 3.901 0 0 0-3.902 3.902c0 2.67 1.976 5.392 4.177 7.554a30.352 30.352 0 0 0 3.831 3.17ZM18.317 7.174a7.148 7.148 0 1 0 0 14.295 7.148 7.148 0 0 0 0-14.295ZM9.443 14.32a8.874 8.874 0 1 1 17.747 0 8.874 8.874 0 0 1-17.747 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M52.605 6.362h-13.5a2.576 2.576 0 0 0-2.569 2.569v9.916c0 .96.536 1.802 1.32 2.243l-1.958 3.195 5.258-2.87h11.449a2.576 2.576 0 0 0 2.569-2.568V8.931a2.576 2.576 0 0 0-2.569-2.569Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M35.674 8.931A3.44 3.44 0 0 1 39.105 5.5h13.5a3.44 3.44 0 0 1 3.432 3.432v9.916a3.44 3.44 0 0 1-3.432 3.432H41.377l-5.065 2.763a.863.863 0 0 1-1.15-1.208l1.55-2.53a3.429 3.429 0 0 1-1.038-2.457V8.931Zm3.431-1.706c-.936 0-1.705.77-1.705 1.706v9.916c0 .632.353 1.196.879 1.492a.863.863 0 0 1 .312 1.203l-.268.437 2.42-1.32a.862.862 0 0 1 .413-.106h11.45c.935 0 1.705-.77 1.705-1.706V8.931c0-.936-.77-1.706-1.706-1.706h-13.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M46.431 12.896h13.5a2.576 2.576 0 0 1 2.569 2.569v9.916c0 .959-.535 1.802-1.319 2.243l1.957 3.194-5.258-2.868H46.431a2.576 2.576 0 0 1-2.569-2.57v-9.915a2.576 2.576 0 0 1 2.57-2.57Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M46.431 13.759c-.936 0-1.706.77-1.706 1.706v9.916c0 .936.77 1.706 1.706 1.706H57.88c.144 0 .286.036.413.105l2.42 1.32-.268-.437a.863.863 0 0 1 .313-1.203c.525-.296.879-.86.879-1.491v-9.916c0-.937-.77-1.706-1.706-1.706h-13.5Zm0-1.726a3.44 3.44 0 0 0-3.432 3.432v9.916a3.44 3.44 0 0 0 3.432 3.432H57.66l5.064 2.763a.863.863 0 0 0 1.15-1.209l-1.55-2.53a3.428 3.428 0 0 0 1.039-2.456v-9.916a3.44 3.44 0 0 0-3.432-3.432h-13.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEmpathy;
